import { FieldConfirmationTypeEnums } from '@/enums/FieldConfirmationTypeEnums';
import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class ConfirmationCardComponent extends Vue {
    @PropSync('modal', { type: Boolean }) public showModal!: boolean;
    @PropSync('modalAction', { type: String }) public header!: string;
    @PropSync('modalBody', { type: String }) public body!: string;
    @PropSync('from', { type: String }) public confirmationFrom!: string;
    @PropSync('type', { type: Number }) public inType!: FieldConfirmationTypeEnums;
    /** Optional label for the confirming button, defaults to 'OK' */
    @Prop({ type: String, default: '' }) public modalYes!: string;

    public usedType: FieldConfirmationTypeEnums = FieldConfirmationTypeEnums.Unknown;
    public types = FieldConfirmationTypeEnums;

    /**
     * The dialog closes itself when the user presses Esc or clicks the overlay.
     * Report that as a cancel, otherwise the flag of the parent stays true and
     * the dialog can not be opened a second time.
     */
    public onVisibilityChanged(inVisible: boolean) {
        if (!inVisible) {
            this.$emit('close');
        }
    }

    get yesText(): string {
        return this.modalYes != null && this.modalYes.length > 0 ? this.modalYes : this.$vuetify.lang.t('$vuetify.buttons.ok');
    }

    @Watch('inType', { immediate: true })
    public inTypeChanged(newValue: FieldConfirmationTypeEnums) {
        this.usedType = newValue;
    }

    @Watch('confirmationFrom', { immediate: true })
    public inFromChanged(newValue: string) {
        if (newValue != null) {
            if (newValue === 'Save') {
                this.usedType = FieldConfirmationTypeEnums.Save;
            } else if (newValue === 'EmptyFilter') {
                this.usedType = FieldConfirmationTypeEnums.EmptyFilter;
            } else {
                this.usedType = FieldConfirmationTypeEnums.Unknown;
            }
        }
    }
}
